export const CALL_TYPES = [
  { value: "emergency", label: "Emergency Response" },
  { value: "standby", label: "Standby" },
  { value: "courtesyTransport", label: "Courtesy Transport" },
];

export const UNIT_ORDER = [
  "BIKE 1",
  "BIKE 2",
  "BIKE 3",
  "CART 3",
  "CART 5",
  "CART 9",
  "CART 12",
  "CART 15",
  "CART 17",
  "SUPERVISOR 1",
  "SUPERVISOR 2",
  "TRANSPORT 1",
  "TRANSPORT 2",
  "TRANSPORT 3",
  "COMMAND 1",
  "COMMAND 2",
  "COMMAND 3",
  "STRETCHER CART MD",
  "STRETCHER CART 3",
];

export const panelStyle = {
  border: "1px solid #23314a",
  borderRadius: 10,
  background: "#0f172a",
  boxShadow: "0 8px 22px rgba(2, 6, 23, 0.35)",
};

export const buttonBase = {
  border: "1px solid #334155",
  background: "#172033",
  color: "#e2e8f0",
  borderRadius: 8,
  padding: "5px 8px",
  cursor: "pointer",
  fontSize: 10,
  fontWeight: 800,
  lineHeight: 1.1,
  minHeight: 28,
};

export const chipButtonBase = {
  border: "1px solid #334155",
  borderRadius: 999,
  padding: "4px 8px",
  cursor: "pointer",
  fontSize: 10,
  fontWeight: 800,
  whiteSpace: "nowrap",
  lineHeight: 1.1,
  minHeight: 26,
};